import type { FaireProductEntity } from "../../entity_types/product";

export const p_msj7z5wahw: FaireProductEntity = {
  token: "p_msj7z5wahw",
  type: "product",
  name: "Hailee Necklace - Turquoise",
  brandToken: "b_d7twym21ud",
  brandName: "Casa Clara",
  imageUrl: "https://cdn.faire.com/fastly/78048a1950261dbf827f6d2285f00822cd4ddaaf3be7088b38e3b175a933d4bb.png",
  galleryImageUrls: [],
  priceDollars: 31,
  description: "Turquoise wood bead necklace with shell pendant\n\n• 16\" with 3\" extender\n• Real shell pendant\n• Handmade in Argentina",
  tags: [],
  msrpDollars: 62,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-14T17:06:53.240Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
